import { DocumentMapping } from "@/configuration/document-mappings/types";
import { Classification } from "@/src/models/constants/classifications";

export const PPCP_MAPPINGS: Partial<Record<Classification, DocumentMapping>> = {
  [Classification.ADMIN]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Fax, Office {{Number}}",
    displayName: "General Admin",
    documentLabel: "{{ documentType }}",
    folder: "Fax, Office {{Number}}",
    folderMapping: "Fax, Office {{Number}}",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN,
    group: "ppcp",
  },
  [Classification.ADMIN_CASE_MANAGER_DOCUMENTS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Fax, Office {{Number}}",
    displayName: "Case Manager Documents",
    documentLabel: "SC-CM NOTE",
    folder: "Fax, Office {{Number}}",
    folderMapping: "Fax, Office {{Number}}",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN_CASE_MANAGER_DOCUMENTS,
    group: "ppcp",
  },
  [Classification.ADMIN_PATIENT_SHARED_INFORMATION]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Fax, Office {{Number}}",
    displayName: "Patient Shared Information (Device Logs)",
    documentLabel: "SC-BSLOG",
    folder: "Fax, Office {{Number}}",
    folderMapping: "Fax, Office {{Number}}",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN_PATIENT_SHARED_INFORMATION,
    group: "ppcp",
  },
  [Classification.ADMIN_POLST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Fax, Office {{Number}}",
    displayName: "POLST",
    documentLabel: "SC-POLST",
    folder: "Fax, Office {{Number}}",
    folderMapping: "Fax, Office {{Number}}",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN_POLST,
    group: "ppcp",
  },
  [Classification.CLEARANCE_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Fax, Office {{Number}}",
    displayName: "Clearance Request",
    documentLabel: "SC-PRE OP",
    folder: "Fax, Office {{Number}}",
    folderMapping: "Fax, Office {{Number}}",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.CLEARANCE_REQUEST,
    group: "ppcp",
  },
  [Classification.COVER_PAGE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Cover Page",
    documentLabel: "",
    folder: null,
    folderMapping: null,
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Delete",
    classification: Classification.COVER_PAGE,
    group: "ppcp",
  },
  [Classification.DME_ORDER]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Fax, Office {{Number}}",
    displayName: "DME Orders",
    documentLabel: "SC-EQUIP",
    folder: "Fax, Office {{Number}}",
    folderMapping: "Fax, Office {{Number}}",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.DME_ORDER,
    group: "ppcp",
  },
  [Classification.FINANCIAL]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Fax, Office {{Number}}",
    displayName: "Financial",
    documentLabel: "SC-PTASSIT",
    folder: "Fax, Office {{Number}}",
    folderMapping: "Fax, Office {{Number}}",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.FINANCIAL,
    group: "ppcp",
  },
  [Classification.IMAGING_RESULTS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Fax, Office {{Number}}",
    displayName: "Radiology/Imaging Report",
    documentLabel: "{{ studyType }}",
    folder: "Fax, Office {{Number}}",
    folderMapping: "Fax, Office {{Number}}",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS,
    group: "ppcp",
  },
  [Classification.IMAGING_RESULTS_CARDIAC]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Fax, Office {{Number}}",
    displayName: "Other Cardiac Report",
    documentLabel: "{{ studyType }}",
    folder: "Fax, Office {{Number}}",
    folderMapping: "Fax, Office {{Number}}",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_CARDIAC,
    group: "ppcp",
  },
  [Classification.IMAGING_RESULTS_CT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Fax, Office {{Number}}",
    displayName: "CT Scans",
    documentLabel: "{{ procedure }}",
    folder: "Fax, Office {{Number}}",
    folderMapping: "Fax, Office {{Number}}",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_CT,
    group: "ppcp",
  },
  [Classification.IMAGING_RESULTS_DEXA]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Documents, Clinical Qualit",
    displayName: "DEXA Scan",
    documentLabel: "SC-DEXA",
    folder: "Documents, Clinical Qualit",
    folderMapping: "Documents, Clinical Qualit",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_DEXA,
    group: "ppcp",
  },
  [Classification.IMAGING_RESULTS_ECHO]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Fax, Office {{Number}}",
    displayName: "Echocardiogram Reports",
    documentLabel: "SC-ECHO",
    folder: "Fax, Office {{Number}}",
    folderMapping: "Fax, Office {{Number}}",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_ECHO,
    group: "ppcp",
  },
  [Classification.IMAGING_RESULTS_EEG]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Fax, Office {{Number}}",
    displayName: "EEG",
    documentLabel: "SC-EEG",
    folder: "Fax, Office {{Number}}",
    folderMapping: "Fax, Office {{Number}}",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_EEG,
    group: "ppcp",
  },
  [Classification.IMAGING_RESULTS_EKG]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Fax, Office {{Number}}",
    displayName: "ECG/EKG",
    documentLabel: "SC-EKG",
    folder: "Fax, Office {{Number}}",
    folderMapping: "Fax, Office {{Number}}",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_EKG,
    group: "ppcp",
  },
  [Classification.IMAGING_RESULTS_EMG]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Fax, Office {{Number}}",
    displayName: "EMG",
    documentLabel: "SC-EMG",
    folder: "Fax, Office {{Number}}",
    folderMapping: "Fax, Office {{Number}}",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_EMG,
    group: "ppcp",
  },
  [Classification.IMAGING_RESULTS_ENDOSCOPY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Documents, Clinical Qualit",
    displayName: "Endoscopy Report (EGD / Sigmoidoscopy)",
    documentLabel: "{{ procedure }}",
    folder: "Documents, Clinical Qualit",
    folderMapping: "Documents, Clinical Qualit",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_ENDOSCOPY,
    group: "ppcp",
  },
  [Classification.IMAGING_RESULTS_ESOPHAGRAM]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Fax, Office {{Number}}",
    displayName: "Esophagram",
    documentLabel: "SC-ESOPHAG",
    folder: "Fax, Office {{Number}}",
    folderMapping: "Fax, Office {{Number}}",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_ESOPHAGRAM,
    group: "ppcp",
  },
  [Classification.IMAGING_RESULTS_HOLTER_MONITOR]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Fax, Office {{Number}}",
    displayName: "Holter Event Monitor Reports",
    documentLabel: "SC-DIAG HM",
    folder: "Fax, Office {{Number}}",
    folderMapping: "Fax, Office {{Number}}",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_HOLTER_MONITOR,
    group: "ppcp",
  },
  [Classification.IMAGING_RESULTS_MAMMOGRAM]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Documents, Clinical Qualit",
    displayName: "Mammogram Report",
    documentLabel: "SC-MAMMO",
    folder: "Documents, Clinical Qualit",
    folderMapping: "Documents, Clinical Qualit",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_MAMMOGRAM,
    group: "ppcp",
  },
  [Classification.IMAGING_RESULTS_MRI]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Fax, Office {{Number}}",
    displayName: "MRI Report",
    documentLabel: "SC-IMG MRI",
    folder: "Fax, Office {{Number}}",
    folderMapping: "Fax, Office {{Number}}",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_MRI,
    group: "ppcp",
  },
  [Classification.IMAGING_RESULTS_PULMONARY_FUNCTION]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Fax, Office {{Number}}",
    displayName: "Pulmonary Function Test",
    documentLabel: "SC-DIAGPFT",
    folder: "Fax, Office {{Number}}",
    folderMapping: "Fax, Office {{Number}}",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_PULMONARY_FUNCTION,
    group: "ppcp",
  },
  [Classification.IMAGING_RESULTS_RETINAL]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Documents, Clinical Qualit",
    displayName: "Retinal / Diabetic Eye Exam",
    documentLabel: "SC-DIA EYE",
    folder: "Documents, Clinical Qualit",
    folderMapping: "Documents, Clinical Qualit",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_RETINAL,
    group: "ppcp",
  },
  [Classification.IMAGING_RESULTS_STRESS_TEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Fax, Office {{Number}}",
    displayName: "Stress Test Report (Exercise / Nuclear)",
    documentLabel: "{{ studyType }}",
    folder: "Fax, Office {{Number}}",
    folderMapping: "Fax, Office {{Number}}",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_STRESS_TEST,
    group: "ppcp",
  },
  [Classification.IMAGING_RESULTS_ULTRASOUND]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Fax, Office {{Number}}",
    displayName: "Ultrasound Report",
    documentLabel: "{{ studyType }}",
    folder: "Fax, Office {{Number}}",
    folderMapping: "Fax, Office {{Number}}",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_ULTRASOUND,
    group: "ppcp",
  },
  [Classification.IMAGING_RESULTS_X_RAY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Fax, Office {{Number}}",
    displayName: "X-Rays",
    documentLabel: "SC-IMG XR",
    folder: "Fax, Office {{Number}}",
    folderMapping: "Fax, Office {{Number}}",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_X_RAY,
    group: "ppcp",
  },
  [Classification.INSURANCE_CARD]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Fax, Office {{Number}}",
    displayName: "Insurance Correspondence",
    documentLabel: "SC-PT INS",
    folder: "Fax, Office {{Number}}",
    folderMapping: "Fax, Office {{Number}}",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.INSURANCE_CARD,
    group: "ppcp",
  },
  [Classification.INSURANCE_COMMUNICATION]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Fax, Office {{Number}}",
    displayName: "Insurance Correspondence",
    documentLabel: "SC-INS MIS",
    folder: "Fax, Office {{Number}}",
    folderMapping: "Fax, Office {{Number}}",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.INSURANCE_COMMUNICATION,
    group: "ppcp",
  },
  [Classification.INTAKE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Fax, Office {{Number}}",
    displayName: "Registration / Intake Forms",
    documentLabel: "{{ intakeNote }}",
    folder: "Fax, Office {{Number}}",
    folderMapping: "Fax, Office {{Number}}",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.INTAKE,
    group: "ppcp",
  },
  [Classification.JUNK]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Junk",
    documentLabel: "",
    folder: null,
    folderMapping: null,
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Delete",
    classification: Classification.JUNK,
    group: "ppcp",
  },
  [Classification.LAB_RESULTS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Fax, Office {{Number}}",
    displayName: "Lab Results",
    documentLabel: "{{ nameOfLab }}",
    folder: "Fax, Office {{Number}}",
    folderMapping: "Fax, Office {{Number}}",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.LAB_RESULTS,
    group: "ppcp",
  },
  [Classification.LAB_RESULTS_BP]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Fax, Office {{Number}}",
    displayName: "BP Logs",
    documentLabel: "{{ nameOfLab }}",
    folder: "Fax, Office {{Number}}",
    folderMapping: "Fax, Office {{Number}}",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.LAB_RESULTS_BP,
    group: "ppcp",
  },
  [Classification.LAB_RESULTS_ORDER_FORM]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Fax, Office {{Number}}",
    displayName: "Lab Orders",
    documentLabel: "{{ isLabAddOn }}",
    folder: "Fax, Office {{Number}}",
    folderMapping: "Fax, Office {{Number}}",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.LAB_RESULTS_ORDER_FORM,
    group: "ppcp",
  },
  [Classification.LAB_RESULTS_PATHOLOGY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Documents, Clinical Qualit",
    displayName: "Pathology Reports",
    documentLabel: "{{ bodyPart }}",
    folder: "Documents, Clinical Qualit",
    folderMapping: "Documents, Clinical Qualit",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.LAB_RESULTS_PATHOLOGY,
    group: "ppcp",
  },
  [Classification.LEGAL_ADVANCED_CARE_DIRECTIVE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Fax, Office {{Number}}",
    displayName: "Advanced Care Directive",
    documentLabel: "{{ documentType }}",
    folder: "Fax, Office {{Number}}",
    folderMapping: "Fax, Office {{Number}}",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.LEGAL_ADVANCED_CARE_DIRECTIVE,
    group: "ppcp",
  },
  [Classification.LEGAL_POWER_OF_ATTORNEY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Fax, Office {{Number}}",
    displayName: "Power of Attorney",
    documentLabel: "SC-POA",
    folder: "Fax, Office {{Number}}",
    folderMapping: "Fax, Office {{Number}}",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.LEGAL_POWER_OF_ATTORNEY,
    group: "ppcp",
  },
  [Classification.MEDICAL_HISTORY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Fax, Office {{Number}}",
    displayName: "Medical History / Records",
    documentLabel: "SC-OLDREC",
    folder: "Fax, Office {{Number}}",
    folderMapping: "Fax, Office {{Number}}",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.MEDICAL_HISTORY,
    group: "ppcp",
  },
  [Classification.MEDICAL_HISTORY_IMMUNIZATION]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Fax, Office {{Number}}",
    displayName: "Immunization Records",
    documentLabel: "{{ isSigned }}",
    folder: "Fax, Office {{Number}}",
    folderMapping: "Fax, Office {{Number}}",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.MEDICAL_HISTORY_IMMUNIZATION,
    group: "ppcp",
  },
  [Classification.MEDICAL_RECORD_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Fax, Record Request",
    displayName: "Medical Record Request",
    documentLabel: "{{ requestingLocation }}",
    folder: "Fax, Record Request",
    folderMapping: "Fax, Record Request",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.MEDICAL_RECORD_REQUEST,
    group: "ppcp",
  },
  [Classification.MEDICAL_RECORD_REQUEST_RESPONSE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Fax, Office {{Number}}",
    displayName: "Medical Records Received (Response)",
    documentLabel: "SC-ROI IN",
    folder: "Fax, Office {{Number}}",
    folderMapping: "Fax, Office {{Number}}",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.MEDICAL_RECORD_REQUEST_RESPONSE,
    group: "ppcp",
  },
  [Classification.NOTIFICATION]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Fax, Office {{Number}}",
    displayName: "Notification",
    documentLabel: "{{ facilityType }}",
    folder: "Fax, Office {{Number}}",
    folderMapping: "Fax, Office {{Number}}",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.NOTIFICATION,
    group: "ppcp",
  },
  [Classification.NOTIFICATION_HOSPITAL_ADMIT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Fax, Office {{Number}}",
    displayName: "Hospital Admit Notification",
    documentLabel: "{{ facilityType }}",
    folder: "Fax, Office {{Number}}",
    folderMapping: "Fax, Office {{Number}}",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.NOTIFICATION_HOSPITAL_ADMIT,
    group: "ppcp",
  },
  [Classification.NOTIFICATION_HOSPITAL_DISCHARGE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Fax, Office {{Number}}",
    displayName: "Hospital Discharge Notification",
    documentLabel: "SC-DC INST",
    folder: "Fax, Office {{Number}}",
    folderMapping: "Fax, Office {{Number}}",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.NOTIFICATION_HOSPITAL_DISCHARGE,
    group: "ppcp",
  },
  [Classification.OPERATION_NOTE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Fax, Office {{Number}}",
    displayName: "Operative Report",
    documentLabel: "SC-OPR RPT",
    folder: "Fax, Office {{Number}}",
    folderMapping: "Fax, Office {{Number}}",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.OPERATION_NOTE,
    group: "ppcp",
  },
  [Classification.ORDER_FROM_PHYSICIAN]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Fax, Office {{Number}}",
    displayName: "Physician Order",
    documentLabel: "{{ bodyPart }}",
    folder: "Fax, Office {{Number}}",
    folderMapping: "Fax, Office {{Number}}",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ORDER_FROM_PHYSICIAN,
    group: "ppcp",
  },
  [Classification.OTHER]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Fax, Office {{Number}}",
    displayName: "Other",
    documentLabel: "{{ documentType }}",
    folder: "Fax, Office {{Number}}",
    folderMapping: "Fax, Office {{Number}}",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.OTHER,
    group: "ppcp",
  },
  [Classification.PHARMACY_RELATED]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Fax, Office {{Number}}",
    displayName: "Pharmacy / Medication (General)",
    documentLabel: "SC-RX NOTE",
    folder: "Fax, Office {{Number}}",
    folderMapping: "Fax, Office {{Number}}",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PHARMACY_RELATED,
    group: "ppcp",
  },
  [Classification.PHARMACY_RELATED_CONTROLED_SUBSTANCES_POLICY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Fax, Office {{Number}}",
    displayName: "Controlled Substance Agreement",
    documentLabel: "SC-CONTSUB",
    folder: "Fax, Office {{Number}}",
    folderMapping: "Fax, Office {{Number}}",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PHARMACY_RELATED_CONTROLED_SUBSTANCES_POLICY,
    group: "ppcp",
  },
  [Classification.PHARMACY_RELATED_MEDICATION_LIST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Fax, Office {{Number}}",
    displayName: "Medication List",
    documentLabel: "SC-EXT MED",
    folder: "Fax, Office {{Number}}",
    folderMapping: "Fax, Office {{Number}}",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PHARMACY_RELATED_MEDICATION_LIST,
    group: "ppcp",
  },
  [Classification.PHARMACY_RELATED_REFILL]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Fax, Office {{Number}}",
    displayName: "Refill Authorization Requests",
    documentLabel: "SC-RX REF",
    folder: "Fax, Office {{Number}}",
    folderMapping: "Fax, Office {{Number}}",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PHARMACY_RELATED_REFILL,
    group: "ppcp",
  },
  [Classification.PRIOR_AUTHORIZATION]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Fax, Office {{Number}}",
    displayName: "Prior Authorization",
    documentLabel: "SC-INS PA",
    folder: "Fax, Office {{Number}}",
    folderMapping: "Fax, Office {{Number}}",
    inputDate: "Date of Document",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PRIOR_AUTHORIZATION,
    group: "ppcp",
  },
  [Classification.PROCEDURE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Fax, Office {{Number}}",
    displayName: "Procedure Report",
    documentLabel: "SC-OF PROC",
    folder: "Fax, Office {{Number}}",
    folderMapping: "Fax, Office {{Number}}",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROCEDURE,
    group: "ppcp",
  },
  [Classification.PROCEDURE_CARDIAC]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Fax, Office {{Number}}",
    displayName: "Cardiac Procedure",
    documentLabel: "{{ procedureCardiacType }}",
    folder: "Fax, Office {{Number}}",
    folderMapping: "Fax, Office {{Number}}",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROCEDURE_CARDIAC,
    group: "ppcp",
  },
  [Classification.PROCEDURE_SLEEP]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Fax, Office {{Number}}",
    displayName: "Sleep Study",
    documentLabel: "SC-DIAG SS",
    folder: "Fax, Office {{Number}}",
    folderMapping: "Fax, Office {{Number}}",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROCEDURE_SLEEP,
    group: "ppcp",
  },
  [Classification.PROGRESS_NOTE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Fax, Office {{Number}}",
    displayName: "Clinic / Consult Notes",
    documentLabel: "{{ specialty }}",
    folder: "Fax, Office {{Number}}",
    folderMapping: "Fax, Office {{Number}}",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROGRESS_NOTE,
    group: "ppcp",
  },
  [Classification.CONTINUITY_OF_CARE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Fax, Office {{Number}}",
    displayName: "Continuity of Care",
    documentLabel: "{{ facilityType }}",
    folder: "Fax, Office {{Number}}",
    folderMapping: "Fax, Office {{Number}}",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.CONTINUITY_OF_CARE,
    group: "ppcp",
  },
  [Classification.PROGRESS_NOTE_ER_REPORT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Fax, Office {{Number}}",
    displayName: "ER Report",
    documentLabel: "SC-ER RPT",
    folder: "Fax, Office {{Number}}",
    folderMapping: "Fax, Office {{Number}}",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROGRESS_NOTE_ER_REPORT,
    group: "ppcp",
  },
  [Classification.PROGRESS_NOTE_HOSPITAL_DISCHARGE_SUMMARY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Fax, Office {{Number}}",
    displayName: "Hospital Discharge Summary",
    documentLabel: "{{ facilityType }}",
    folder: "Fax, Office {{Number}}",
    folderMapping: "Fax, Office {{Number}}",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROGRESS_NOTE_HOSPITAL_DISCHARGE_SUMMARY,
    group: "ppcp",
  },
  [Classification.PROGRESS_NOTE_HOSPITAL_RECORDS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Fax, Office {{Number}}",
    displayName: "Hospital Records (H&P)",
    documentLabel: "SC-HOSP HP",
    folder: "Fax, Office {{Number}}",
    folderMapping: "Fax, Office {{Number}}",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROGRESS_NOTE_HOSPITAL_RECORDS,
    group: "ppcp",
  },
  [Classification.PROGRESS_NOTE_PT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Fax, Office {{Number}}",
    displayName: "Physical Therapy Notes",
    documentLabel: "{{ encounterType }}",
    folder: "Fax, Office {{Number}}",
    folderMapping: "Fax, Office {{Number}}",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROGRESS_NOTE_PT,
    group: "ppcp",
  },
  [Classification.PROGRESS_NOTE_VITAL_CHART]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Fax, Office {{Number}}",
    displayName: "Vitals Log",
    documentLabel: "SC-VITAL",
    folder: "Fax, Office {{Number}}",
    folderMapping: "Fax, Office {{Number}}",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROGRESS_NOTE_VITAL_CHART,
    group: "ppcp",
  },
  [Classification.REFERRAL_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Fax, Office {{Number}}",
    displayName: "Referral Request",
    documentLabel: "SC-REFREQ",
    folder: "Fax, Office {{Number}}",
    folderMapping: "Fax, Office {{Number}}",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.REFERRAL_REQUEST,
    group: "ppcp",
  },
  [Classification.REFERRAL_RESPONSE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Fax, Office {{Number}}",
    displayName: "Consultation Report / Referral Response",
    documentLabel: "{{ specialty }}",
    folder: "Fax, Office {{Number}}",
    folderMapping: "Fax, Office {{Number}}",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.REFERRAL_RESPONSE,
    group: "ppcp",
  },
} as const;
